import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../config";
import DataTable_v2 from "../components/DataTable_v2";
import Swal from "sweetalert2";
import UserDataTable from "../components/UserDataTable";
import UserDataTablePage_v2 from "./UserDataTablePage_v2";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; // Import FontAwesome
import {faUsers,faUsersCog} from "@fortawesome/free-solid-svg-icons"; // Import specific icons

const UserManagement = () => {
  // const [users, setUsers] = useState([]);
  // const [loading, setLoading] = useState(true);

  // const fetchUsers = async () => {
  //   try {
  //     const response = await axios.get(`${BASE_URL}/admin/users`, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
  //       },
  //     });
  //     setUsers(response.data.data);
  //   } catch (error) {
  //     console.error("Error fetching users:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchUsers();
  // }, []);

  // const handleDelete = async (username) => {
  //   const result = await Swal.fire({
  //     title: "Are you sure?",
  //     text: "You are about to delete this user!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes, delete it!",
  //   });

  //   if (result.isConfirmed) {
  //     try {
  //       await axios.delete(`${BASE_URL}/admin/users/${username}`, {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
  //         },
  //       });
  //       Swal.fire("Deleted!", "The user has been deleted.", "success");
  //       fetchUsers();
  //     } catch (error) {
  //       Swal.fire("Error!", "Failed to delete the user.", "error");
  //     }
  //   }
  // };

  // const columns = [
  //   { key: "username", label: "Username", sortable: true },
  //   { key: "email", label: "Email", sortable: true },
  //   { key: "created_at", label: "Created At", sortable: true },
  //   { key: "updated_at", label: "Updated At", sortable: true },
  //   {
  //     key: "actions",
  //     label: "Actions",
  //     sortable: false,
  //     render: (row) => (
  //       <div className="flex space-x-2">
  //         <button
  //           onClick={() => handleDelete(row.username)}
  //           className="text-red-500 hover:text-red-700"
  //         >
  //           Delete
  //         </button>
  //       </div>
  //     ),
  //   },
  // ];

  return (
    <div className="p-3">
      {/* Header */}
      <div className="flex items-center gap-3 mb-2">
        <div className="p-2 bg-white rounded-lg shadow-xs border border-gray-100">
          <FontAwesomeIcon
            icon={faUsersCog}
            className="text-lg text-purple-600"
          />
        </div>
        <div>
          <h1 className="text-lg font-semibold text-gray-800">
          User Management
          </h1>
          <p className="text-xs text-gray-500 mt-0.5">List of Users</p>
        </div>
      </div>
      <UserDataTablePage_v2 />
    </div>
  );
};

export default UserManagement;
